import { useCallback } from 'react';

import { useStoreContext } from 'features/store';

import { ISystemwideTierGroupFragment } from 'generated/sanity-graphql';
import usePosVendor from 'hooks/menu/use-pos-vendor';
import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { useServiceModeContext } from 'state/service-mode';
import { useUnifiedMenuContext } from 'state/unified-menu';
import { PosServiceMode } from 'state/unified-menu/types';

import { processTierGroup_Legacy } from './legacy';
import { processTierGroup_UnifiedMenu } from './one-menu';

export function useTierGroupProcessor() {
  const { prices } = useStoreContext();
  const { vendor } = usePosVendor();
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();
  const { indexedMenu, isLoading: isLoadingIndexedMenu } = useUnifiedMenuContext();
  const { serviceMode } = useServiceModeContext();

  const processTierGroup = useCallback(
    (item: ISystemwideTierGroupFragment) => {
      let selectedOffer = null;
      if (!isUnifiedMenuEnabled && vendor) {
        selectedOffer = processTierGroup_Legacy(item, vendor, prices);
      } else if (isUnifiedMenuEnabled && indexedMenu && !isLoadingIndexedMenu) {
        const posServiceMode: PosServiceMode = serviceMode === 'DELIVERY' ? 'delivery' : 'pickup';
        selectedOffer = processTierGroup_UnifiedMenu(item, indexedMenu, posServiceMode);
      }
      return { selectedOffer };
    },
    [isUnifiedMenuEnabled, indexedMenu, isLoadingIndexedMenu, serviceMode, vendor, prices]
  );

  return {
    processTierGroup,
  };
}
